/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@charset \"UTF-8\";.app-expansion-panel-content{overflow:hidden}.app-expansion-panel-content.app-expanded{overflow:visible}.app-expansion-panel-body{padding:0 15px 8px}.app-expansion-panel:not(:last-child){margin-bottom:4px;display:block;transition:margin 225ms cubic-bezier(.4,0,.2,1)}"];
export { styles as styles };
